import useLogger from 'lib/util/useLogger'

const debug = useLogger('lightslategrey')

/**
 * Parse the (sub) utilities contained within a product
 *
 * @param {Array} list - the list of utilities
 * @param {object} utilityConfig - the utility config
 * @returns {Array} the parsed utilities
 */
export default function parseSubUtility (list, utilityConfig) {
  if (!Array.isArray(list)) {
    return []
  }

  const validUtilities = Object.keys(utilityConfig)

  return list.reduce((res, item) => {
    const category = String(item?.utility || '').toLowerCase()

    if (!validUtilities.includes(category)) {
      debug.log('Utility with key does not exist', category)

      return res
    }

    res.push({
      ...item,
      name: item?.name,
      description: item?.description,
      summary: item?.summary ? item?.summary : null,
      details: Array.isArray(item?.details) ? item?.details : [],
      utility: category
    })

    return res
  }, [])
}
